import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { faCog, faAngleRight, faPlus, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedObject } from 'src/app/helper/validation';
//import { LoginComponent } from 'src/app/login/login.component';
import { SharedService } from '../../helper/shared/shared.service';
import { ProjectService } from '../../project/project.service';
import { UserInfoService } from '../../user-info/user-info.service';
import { CalculateService } from '../../helper/calculate/calculate.service';
import { ProgramSettingsService } from '../../program-settings/program-settings.service';
import { faBookReader } from '@fortawesome/free-solid-svg-icons';
import { createPopper } from '@popperjs/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router  } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
  selector: 'app-contamination',
  templateUrl: './contamination.component.html',
  styleUrls: ['./contamination.component.scss']
})

export class ContaminationComponent implements OnInit {
  @Output() nextStep = new EventEmitter<String>();

  @ViewChild('selectOtherGasPopUp', {static: false} ) othersGasModal : any;
  //@ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  @ViewChild('txtAirflow', {static: true} ) txtAirflow:any;
  @ViewChild('datalistAirflow', {static: true} ) datalistAirflow:any;

  @ViewChild('txtTemperature', {static: true} ) txtTemperature:any;
  @ViewChild('datalistTemperature', {static: true} ) datalistTemperature:any;

  @ViewChild('txtRH', {static: true} ) txtRH:any;
  @ViewChild('datalistRH', {static: true} ) datalistRH:any;

  @ViewChild('txtApplication', {static: true} ) txtApplication:any;
  @ViewChild('datalistApplication', {static: true} ) datalistApplication:any;

  @ViewChild('txtOtherGas', {static: false} ) txtOtherGas:any;
  @ViewChild('datalistOtherGas', {static: false} ) datalistOtherGas:any;

  //@ViewChild('txtContamination', {static: true} ) txtContamination:any;
  @ViewChild('txtContamination0', {static: false} ) txtContamination0;
  @ViewChild('txtContamination1', {static: false} ) txtContamination1;
  @ViewChild('txtContamination2', {static: false} ) txtContamination2;

  //@ViewChild('datalistContamination', {static: true} ) datalistContamination:any;
  @ViewChild('datalistContamination0', {static: false} ) datalistContamination0;
  @ViewChild('datalistContamination1', {static: false} ) datalistContamination1;
  @ViewChild('datalistContamination2', {static: false} ) datalistContamination2;

  faCog = faCog;
  faPlus = faPlus;
  faInfoCircle = faInfoCircle;
  faAngleRight = faAngleRight;

  AllDDLList: any;
  airflowList: any;
  temperatureList: any;
  RHList: any;
  applicationList: any=[];
  contaminationList: any;
  //Modified by JW(2022-10-05): filter dropdown list based on input entries-start
  //contaminationList1: any;
  //contaminationList2: any;
  //contaminationList3: any;
  //Modified by JW(2022-10-05): filter dropdown list based on input entries-end
  chemicalListBasedOnSelectedApp: any;  //Modified by JW(2022-10-05): filter dropdown list based on input entries
  otherGassesList: any;
  datalistShow="";
  airflowUnit: string;
  //airflowvalue: string;
  //temperatureUnit: string;
  inum: number = 0;
  selectedContaminationList: any;

  AddContaminationInfo: any;
  UnitsFromUserData: any;

  NumberFormat = '';
  contaminationType1: string;
  contaminationType2: string;
  contaminationType3: string;
  contamination;

  solutions;
  
  displayTypeForMoreInfo1: string;
  displayTypeForMoreInfo2: string;
  displayTypeForMoreInfo3: string;

  closeResult: string;
  OtherGasID: number;
  OtherGasName: string;
  OtherGasChemFormula: string;
  OtherGasDensity: 0;
  OtherGasMolWeight: 0;
  OtherGasBoilingPoint: 0;
  OtherGasRefractiveIndex: 0;
  OtherGasVapourPressure: 0;

  flag = false;
  contaminationChanged = false;

  // For Program Settings PopUp - START
  unitlist: any = this.programSettingsService.unitList;
  concUnitlist: any;
  airFlowUnitlist: any;
  formatlist: any = this.programSettingsService.formatList;

  userUnit = this.projectService.projectdetails.projectInfo.unitId;
  selectedConcUnit = "";

  selConcUnitFromProgSettings = "";
  selUnitFromProgSettings = 0;
  selAirFlowUnitFromProgSettings = "";

  disableFlag = false;
  // For Program Settings PopUp - END

  constructor(
    private toastr: ToastrService,
    public sharedService: SharedService,
    public projectService: ProjectService,
    private userInfoService: UserInfoService,
    private calculateService: CalculateService,
    private modalService: NgbModal,
    public programSettingsService: ProgramSettingsService,
    private router : Router //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.projectService.activePage = 3;

    this.displayTypeForMoreInfo1 = "More Information";
    this.displayTypeForMoreInfo2 = "More Information";
    this.displayTypeForMoreInfo3 = "More Information";

    this.contamination = this.projectService.getContaminationEmptyValueStructure();
    this.contamination = this.projectService.projectdetails.contamination;
    this.solutions = this.projectService.projectdetails.solutions;
    
    if(this.projectService.projectdetails.contamination.gasDetails.length == 0) {
      this.addContamination();
    } else {
      this.InsertDataIntoEachContaminatinBoxes();
    }

    if (this.userInfoService.userData.NumberFormatId === 1) {
      this.NumberFormat = 'sv-SE';
    } else if (this.userInfoService.userData.NumberFormatId === 2) {
      this.NumberFormat = 'en-US';
    }

    this.initiateList();
    this.initiateData();
  }

  //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-start
  // ngAfterViewInit(){
  //   this.setPoppers();
  // }

  ngAfterViewInit(){
    this.setPoppers();
    if (this.contaminationType1 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination0')).value = this.contaminationType1;
      let itemGas = {
        ChemicalID: this.contamination.gasDetails[0].chemicalID
      };
      this.selectContaminationType(itemGas,0);
    }
    if (this.contaminationType2 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination1')).value = this.contaminationType2;
      let itemGas = {
        ChemicalID: this.contamination.gasDetails[1].chemicalID
      };
      this.selectContaminationType(itemGas,1);
    }
    if (this.contaminationType3 !== undefined) {
      (<HTMLInputElement>document.getElementById('txtContamination2')).value = this.contaminationType3;
      let itemGas = {
        ChemicalID: this.contamination.gasDetails[2].chemicalID
      };
      this.selectContaminationType(itemGas,2);
    }
  }

  ngOnChanges() {
    var abc=123;
  }

  ngAfterContentInit() {
    var abc=123;
  }
  //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-end

  ngOnDestroy() {
    if (this.contaminationChanged) {
    
      //this.projectService.projectdetails.solutions = [];
      //this.projectService.projectdetails.solutions = [this.projectService.getSolutionsForComparisonEmptyValueStructure()]
    }

    if (this.projectService.valid['contamination'] === 'Skipped') {
      this.projectService.valid['contamination'] = '';
    }else {
      this.Proceed();
    }
    this.sharedService.blnLoadFromRecord = false;
  }

  initiateList() {
    this.AllDDLList = this.sharedService.listData;
    if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
      this.airflowList = this.AllDDLList.SI_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.SI_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.SI_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.SI_List.AirFlowUnits;
    }else{
      this.airflowList = this.AllDDLList.US_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.US_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.US_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.US_List.AirFlowUnits;
    }

    this.temperatureList = this.AllDDLList.Temperature.List;
    this.RHList = this.AllDDLList.Humidity.List;   
    this.otherGassesList = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord;

    for (var i=0;i<this.sharedService.ApplicationChemicalList.length;i++) {
      var chemList = [];
      for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
        let tmpEachRec = {
          ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
          substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
        }
        chemList.push(tmpEachRec);      
      }
      let tmpRec = {
        id: this.sharedService.ApplicationChemicalList[i].id,
        name: this.sharedService.ApplicationChemicalList[i].name,
        chemicalList: chemList
      }
      this.applicationList.push(tmpRec);
    }

    //For this.contaminationList
    for (var i=0;i<this.sharedService.ApplicationChemicalList.length;i++) {
      if (this.contamination.applicationType === '') {
        if (this.sharedService.ApplicationChemicalList[i].id == 0 && this.sharedService.ApplicationChemicalList[i].name == 'ALL') {
          this.contaminationList = [];       
          for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
            let tmpGas = {
              ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
              substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
            }
            this.contaminationList.push(tmpGas);     
          }
        }
      } else {
        if(this.contamination.applicationType === this.sharedService.ApplicationChemicalList[i].name ) {
          this.contaminationList = [];
          //this.chemicalListBasedOnSelectedApp = [];
          for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
            let tmpGas = {
              ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
              substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
            }
            this.contaminationList.push(tmpGas);        
          }
        }
      }   
    }

    //this.chemicalListBasedOnSelectedApp
    for (var i=0;i<this.sharedService.ApplicationChemicalList.length;i++) {
      if (this.contamination.applicationType === '') {
        if (this.sharedService.ApplicationChemicalList[i].id == 0 && this.sharedService.ApplicationChemicalList[i].name == 'ALL') {              
          this.chemicalListBasedOnSelectedApp = [];
          for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
            let tmpGas = {
              ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
              substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
            }
            this.chemicalListBasedOnSelectedApp.push(tmpGas);
          }
        }
      } else {
        if(this.contamination.applicationType === this.sharedService.ApplicationChemicalList[i].name ) {
          this.chemicalListBasedOnSelectedApp = [];
          for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
            let tmpGas = {
              ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
              substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
            }        
            this.chemicalListBasedOnSelectedApp.push(tmpGas);
          }
        }
      }   
    }
  }

  initiateListORI() {
    this.AllDDLList = this.sharedService.listData;
    if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
      this.airflowList = this.AllDDLList.SI_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.SI_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.SI_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.SI_List.AirFlowUnits;
    }else{
      this.airflowList = this.AllDDLList.US_List.AirFlow.List;
      this.temperatureList = this.AllDDLList.US_List.Temperature.List;
      this.concUnitlist = this.AllDDLList.US_List.ConcentrationUnits;
      this.airFlowUnitlist = this.AllDDLList.US_List.AirFlowUnits;
    }

    this.temperatureList = this.AllDDLList.Temperature.List;
    this.RHList = this.AllDDLList.Humidity.List;
    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
    //this.applicationList = this.AllDDLList.ApplicationChemicalList;
    //this.otherGassesList = this.AllDDLList.ApplicationContaminationFromServer.CLDSaveOthersRecord;
    this.otherGassesList = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord;

    //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - START
    //this.applicationList = this.sharedService.ApplicationChemicalList;
    for (var i=0;i<this.sharedService.ApplicationChemicalList.length;i++) {
      var chemList = [];
      for (var j=0;j<this.sharedService.ApplicationChemicalList[i].chemicalList.length;j++) {
        let tmpEachRec = {
          ChemicalID: this.sharedService.ApplicationChemicalList[i].chemicalList[j].ChemicalID,
          substance: this.sharedService.ApplicationChemicalList[i].chemicalList[j].substance
        }
        chemList.push(tmpEachRec);      
      }
      let tmpRec = {
        id: this.sharedService.ApplicationChemicalList[i].id,
        name: this.sharedService.ApplicationChemicalList[i].name,
        chemicalList: chemList
      }
      this.applicationList.push(tmpRec);
    }
    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END
    //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - END

    for (var x=0;x<this.applicationList.length;x++) {
      if (this.contamination.applicationType === '') {
        if (this.applicationList[x].id == 0 && this.applicationList[x].name == 'ALL') {
          //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - START
          // this.contaminationList = this.applicationList[x].chemicalList;
          // this.chemicalListBasedOnSelectedApp = this.contaminationList;
          // this.contaminationList1 = this.contaminationList;
          // this.contaminationList2 = this.contaminationList;
          // this.contaminationList3 = this.contaminationList;

          this.contaminationList = [];       
          this.chemicalListBasedOnSelectedApp = [];
          for (var y=0;y<this.applicationList[x].chemicalList.length;y++) {
            let tmpGas = {
              ChemicalID: this.applicationList[x].chemicalList[y].ChemicalID,
              substance: this.applicationList[x].chemicalList[y].substance
            }
            this.contaminationList.push(tmpGas);
            this.chemicalListBasedOnSelectedApp.push(tmpGas);
          }                 
          //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - END
        }
      }else {
        if(this.contamination.applicationType === this.applicationList[x].name ) {
          //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - START
          // this.contaminationList = this.applicationList[x].chemicalList;
          // this.chemicalListBasedOnSelectedApp = this.contaminationList;
          // this.contaminationList1 = this.contaminationList;
          // this.contaminationList2 = this.contaminationList;
          // this.contaminationList3 = this.contaminationList;

          this.contaminationList = [];
          this.chemicalListBasedOnSelectedApp = [];
          for (var y=0;y<this.applicationList[x].chemicalList.length;y++) {
            let tmpGas = {
              ChemicalID: this.applicationList[x].chemicalList[y].ChemicalID,
              substance: this.applicationList[x].chemicalList[y].substance
            }

            this.contaminationList.push(tmpGas);           
            this.chemicalListBasedOnSelectedApp.push(tmpGas);
          }                 
          //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas - END
        }
      }
    }
    //Modified by JW(2022-10-05): filter dropdown list based on input entries-end
  }

  //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - START
  initiateData() {    
    // if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
    //   //this.temperatureUnit = this.AllDDLList.UnitInfoClass.UnitInfo_SI.Temperature;
    //   //this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_SI.Airflow;
    //   this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
    // } else {
    //   //this.temperatureUnit = this.AllDDLList.UnitInfoClass.UnitInfo_US.Temperature;
    //   //this.contamination.airflowUnit = this.AllDDLList.UnitInfoClass.UnitInfo_US.Airflow;
    //   this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
    // }

    if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
    } else {
      this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
    }   

    //Modified by PP(2023-05-06) : After change airflow/temperature value, go to other pages and come back it takes default value if (this.projectService.projectdetails.projectInfo.id === 0) { 
    if (this.contamination.airflow == 0 || this.contamination.airflow == '') { // Take Default Value
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {        
        this.contamination.airflow = this.sharedService.formatValue(this.AllDDLList.SI_List.AirFlow.DefaultValue, true);      
        //let tmpTemp = parseFloat(this.AllDDLList.SI_List.Temperature.DefaultValue);
        let tmpTemp = this.sharedService.convertLocaletoNumber(this.AllDDLList.SI_List.Temperature.DefaultValue, this.NumberFormat);
        this.contamination.temperature = this.sharedService.formatValue(tmpTemp, true);
        this.selUnitFromProgSettings = 1;
        this.disableFlag=false;
      } else {        
        this.contamination.airflow = this.sharedService.formatValue(this.AllDDLList.US_List.AirFlow.DefaultValue, true);       
        //let tmpTemp = parseFloat(this.AllDDLList.US_List.Temperature.DefaultValue);
        let tmpTemp = this.sharedService.convertLocaletoNumber(this.AllDDLList.US_List.Temperature.DefaultValue, this.NumberFormat);
        this.contamination.temperature = this.sharedService.formatValue(tmpTemp, true);
        this.selUnitFromProgSettings = 2;
        this.disableFlag=true;
      }
    }else{     
      this.contamination.airflow = this.sharedService.formatValue(this.projectService.projectdetails.contamination.airflow, true);
      //let tmpTemp = parseFloat(this.projectService.projectdetails.contamination.temperature);
      let tmpTemp = this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.contamination.temperature, this.NumberFormat);
      this.contamination.temperature = this.sharedService.formatValue(tmpTemp, true);
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        this.selUnitFromProgSettings = 1;
        this.disableFlag=false;
      } else {
        this.selUnitFromProgSettings = 2;
        this.disableFlag=true;
      }
    }
    
    if (this.contamination.airflowUnit !== "" && this.contamination.airflow !== undefined) {
      switch (this.contamination.airflowUnit) {
        case "m³/h":
          this.selAirFlowUnitFromProgSettings = "m³/h";
          break;
        case "CFM":
          this.selAirFlowUnitFromProgSettings = "CFM";
          break;
        case "m³/s":
          this.selAirFlowUnitFromProgSettings = "m³/s";
          break;
        case "L/s":
          this.selAirFlowUnitFromProgSettings = "L/s";
          break;
      }
    }

    if (this.contamination.applicationType === "") {
      this.contamination.applicationType = "ALL"
    }
    //this.userInfoService.userData.UserConcUnit

    switch (this.userInfoService.userData.UserConcUnit) {
      case "ppb":
        this.selectedConcUnit = "ppb";
        this.selConcUnitFromProgSettings = "ppb";
        break;
      case "mg/m³":
        this.selectedConcUnit = "mg/m³";
        this.selConcUnitFromProgSettings = "mg/m³";
        break;
    }
  }
  //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - END

  //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-start
  // onFocusEvent(ele:string, pIndex:number){
  //   let input:any;
  //   let datalist:any;
  //   let elementName=ele;
  //   switch (ele) {
  //     case 'Airflow':
  //       input = this.txtAirflow.nativeElement;
  //       datalist = this.datalistAirflow.nativeElement;
  //       break;
  //     case 'Temperature':
  //       input = this.txtTemperature.nativeElement;
  //       datalist = this.datalistTemperature.nativeElement;
  //       break;
  //     case 'RH':
  //       input = this.txtRH.nativeElement;
  //       datalist = this.datalistRH.nativeElement;
  //       break;
  //     case 'Application':
  //       input = this.txtApplication.nativeElement;
  //       datalist = this.datalistApplication.nativeElement;
  //       break;
  //     case 'Contamination1':
  //       input = this.txtContamination0.nativeElement;
  //       datalist = this.datalistContamination0.nativeElement;
  //       break;
  //     case 'Contamination2':
  //       input = this.txtContamination1.nativeElement;
  //       datalist = this.datalistContamination1.nativeElement;
  //       break;
  //     case 'Contamination3':
  //       input = this.txtContamination2.nativeElement;
  //       datalist = this.datalistContamination2.nativeElement;
  //       break;
  //     case 'OtherContamination':
  //       input = document.getElementById('txtOtherGas');
  //       datalist = document.getElementById('datalistOtherGas');
  //       break;
  //   }

  //   this.hideAllDataList(input.id);
  //   let me = this;
  //   this.datalistShow = elementName;
  //   datalist.style.display = 'block';

  //   for (let option of datalist.options) {
  //     option.onclick = function () {
  //       input.value = this.value;
  //       switch(ele){
  //         case "Airflow":
  //           //me.projectService.projectdetails.contamination.airflow = input.value;
  //           //me.formatNumber('airflow',me.projectService.projectdetails.contamination.airflow);
  //           me.contamination.airflow = input.value;
  //           me.formatNumber('airflow',me.contamination.airflow, pIndex);
  //           break;
  //         case "Temperature":
  //           me.contamination.temperature = input.value;
  //           me.formatNumber('temperature',me.contamination.temperature, pIndex);
  //           break;
  //         case "RH":
  //           me.contamination.relativeHumidity = input.value;
  //           me.formatNumber('relativeHumidity',me.contamination.relativeHumidity, pIndex);
  //           break;
  //         case "Application":
  //           me.contamination.applicationType = input.value;
  //           break;
  //         case "Contamination1":
  //           me.contaminationType1 = input.value;
  //           break;
  //         case "Contamination2":
  //           me.contaminationType2 = input.value;
  //           break;
  //         case "Contamination3":
  //           me.contaminationType3 = input.value;
  //           break;
  //         case 'OtherContamination':
  //           //me.contamination.gasDetails[me.sharedService.currentIndexForOtherGas].otherGasDetails.otherContaminantName = input.value;
  //           me.OtherGasName = input.value;
  //           me.selectOtherGas(input.value);
  //       }
  //       datalist.style.display = 'none';
  //       this.datalistShow="";
  //     }
  //   }
  //   datalist.style.width = input.offsetWidth + 'px';
  //   datalist.style.left = input.offsetLeft + 'px';
  //   datalist.style.top = input.offsetTop + input.offsetHeight + 'px';
  // }

  onFocusEvent(ele:string, pIndex:number){
    let input:any;
    let datalist:any;
    let tmpTxtBox: any;
    let tmpDataList :any;
    let elementName=ele;
    switch (ele) {
      case 'Airflow':
        input = this.txtAirflow.nativeElement;
        datalist = this.datalistAirflow.nativeElement;
        break;
      case 'Temperature':
        input = this.txtTemperature.nativeElement;
        datalist = this.datalistTemperature.nativeElement;
        break;
      case 'RH':
        input = this.txtRH.nativeElement;
        datalist = this.datalistRH.nativeElement;
        break;
      case 'Application':
        input = this.txtApplication.nativeElement;
        datalist = this.datalistApplication.nativeElement;
        break;
      case 'Contamination':
        tmpTxtBox = 'txtContamination' + pIndex.toString();
        tmpDataList = 'datalistContamination' + pIndex.toString();
        input = document.getElementById(tmpTxtBox);
        datalist = document.getElementById(tmpDataList);
        elementName = ele + pIndex.toString();
        switch (pIndex) {
          case 0:
           //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas this.contaminationList = this.contaminationList1;
            break;
          case 1:
             //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas this.contaminationList = this.contaminationList2;            
            break;
          case 2:
            //Modified by PP(2023-05-12) : Bugs. If duplicate gas selected, the dropdown list is empty for the affected gas this.contaminationList = this.contaminationList3;            
            break;
        }
        break;
      case 'OtherContamination':
        input = document.getElementById('txtOtherGas');
        datalist = document.getElementById('datalistOtherGas');       
        break;
    }

    this.hideAllDataList(input.id);
    let me = this;
    this.datalistShow = elementName;
    datalist.style.display = 'block';

    for (let option of datalist.options) {
      option.onclick = function () {
        input.value = this.value;
        switch(ele){
          case "Airflow":
            me.contamination.airflow = input.value;
            me.formatNumber('airflow',me.contamination.airflow, pIndex);
            break;
          case "Temperature":
            me.contamination.temperature = input.value;
            me.formatNumber('temperature',me.contamination.temperature, pIndex);
            break;
          case "RH":
            me.contamination.relativeHumidity = input.value;
            me.formatNumber('relativeHumidity',me.contamination.relativeHumidity, pIndex);
            break;
          case "Application":
            me.contamination.applicationType = input.value;
            break;
          case "Contamination1":
            me.contaminationType1 = input.value;
            break;
          case "Contamination2":
            me.contaminationType2 = input.value;
            break;
          case "Contamination3":
            me.contaminationType3 = input.value;
            break;
          case 'OtherContamination':
            //me.contamination.gasDetails[me.sharedService.currentIndexForOtherGas].otherGasDetails.otherContaminantName = input.value;
            me.OtherGasName = input.value;
            me.selectOtherGas(input.value);
        }
        datalist.style.display = 'none';
        this.datalistShow="";

        //Trigger Calculation here
        if (ele != 'Application') {
          me.triggerCalculation();
        }      
      }
    }
    datalist.style.width = input.offsetWidth + 'px';
    datalist.style.left = input.offsetLeft + 'px';
    datalist.style.top = input.offsetTop + input.offsetHeight + 'px';
  }
//Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-end

//Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-start
  // hideAllDataList(exclude){
  //   let aryDatalist=[this.datalistAirflow, this.datalistTemperature, this.datalistRH, this.datalistApplication];
  //   let aryDatalistName=['airflow', 'temperature', 'RH', 'application', 'otherContamination'];
  //   for (var x=0;x<aryDatalist.length;x++){
  //     let datalist = aryDatalist[x].nativeElement;
  //     let name=aryDatalistName[x];
  //     if (datalist.style.display==='block' && name!==exclude ){
  //       datalist.style.display = 'none';
  //     }
  //   }
  // }

  hideAllDataList(exclude){
    let datalist;
    let name;
    let blnGetElementbyID = false;
    blnGetElementbyID =  exclude.includes("txt");
    if (blnGetElementbyID) {
      let aryDatalist=['datalistContamination0','datalistContamination1','datalistContamination2'];
      let aryDatalistName=['txtContamination0','txtContamination1','txtContamination2','otherContamination'];
      for (var i=0; i<aryDatalist.length; i++) {
        datalist = document.getElementById(aryDatalist[i]);
        name = aryDatalistName[i];
        if (datalist !== null && datalist.style.display==='block' && name!==exclude) {
          datalist.style.display = 'none';
        }
      }
    }else{
      let aryDatalist=[this.datalistAirflow, this.datalistTemperature, this.datalistRH, this.datalistApplication];
      let aryDatalistName=['airflow', 'temperature', 'RH','application'];
      for (var x=0;x<aryDatalist.length;x++){
        if (aryDatalist[x] != undefined) {
          datalist = aryDatalist[x].nativeElement;
          name = aryDatalistName[x];
          if (datalist.style.display==='block' && name!==exclude ){
            datalist.style.display = 'none';
          }
        }      
      }
    }
  }
  //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-end

  tabkeyChanges(e: MouseEvent) {
    this.onMouseClick(e);
  }

  onMouseClick(e: MouseEvent){
    if(this.datalistShow!=="") {
      let input:any;
      let datalist:any;
      let previousdatalist:any;
      let targetElementIsNotInput = false;
      //let datalistHeight,datalistWidth,datalistXPosition,datalistYPosition,WindowXPosition,WindowYPosition, dialogBoxXPosition, dialogBoxYPosition =0;
      //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12-start
      //input = this.getElementName(this.datalistShow, "Input");
      //datalist = this.getElementName(this.datalistShow, "DataList");
      switch (this.datalistShow) {
        case "Contamination0":
          input = document.getElementById('txtContamination0');
          datalist = document.getElementById('datalistContamination0');
          break;
        case "Contamination1":
          input = document.getElementById('txtContamination1');
          datalist = document.getElementById('datalistContamination1');
          break;
        case "Contamination2":
          input = document.getElementById('txtContamination2');
          datalist = document.getElementById('datalistContamination2');
          break;
        default:
          input = this.getElementName(this.datalistShow, "Input");
          datalist = this.getElementName(this.datalistShow, "DataList");
          break;
      }
      //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12

      if (e.target== input) {
        if (this.sharedService.previousClickedDataList != "") {
          previousdatalist = this.getElementName(this.sharedService.previousClickedDataList, "DataList");
          previousdatalist.style.display = 'none';
          this.sharedService.previousClickedDataList = "";
        }
      }

      let clickOnDatalistArea=false;
      let targetElement = e.target;
      if (targetElement == input) {
        clickOnDatalistArea=true;
        this.sharedService.previousClickedDataList = this.datalistShow;
      } else {
        targetElementIsNotInput = true;
        clickOnDatalistArea=false;
      }

      //Bug appear after clicking all 3 contaminants and click on Type dropdownlist, the datalist appear and hide away
      var tag = (<Element>e.target).innerHTML;
      if( tag.indexOf('Type') >= 0 && !targetElementIsNotInput){
        clickOnDatalistArea = true;
      }

      console.log("clickOnDatalistArea =>  (" + clickOnDatalistArea + " )");
      if (clickOnDatalistArea===false){
        if (datalist != undefined) {
          datalist.style.display = 'none';
        }      
        this.sharedService.previousClickedDataList = "";
      }
    }
  }

  getElementName(whichElement:string, whichType:string) {
    let requiredElement: any;
    switch(whichElement) {
      case "Airflow":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtAirflow.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistAirflow.nativeElement;
          break;
        }
       break;
       case "Temperature":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtTemperature.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistTemperature.nativeElement;
          break;
        }
       break;
       case "RH":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtRH.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistRH.nativeElement;
          break;
        }
       break;
      case "Application":
        switch (whichType) {
          case "Input":
            requiredElement = this.txtApplication.nativeElement;
          break;

          case "DataList":
            requiredElement=this.datalistApplication.nativeElement;
          break;
        }
        break;
      case "Contamination0":
        switch (whichType) {
          case "Input":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement = this.txtContamination0.nativeElement;
            requiredElement = document.getElementById('txtContamination0');
          break;

          case "DataList":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement=this.datalistContamination0.nativeElement;
            requiredElement = document.getElementById('datalistContamination0');
          break;
        }
        break;
      case "Contamination1":
        switch (whichType) {
          case "Input":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement = this.txtContamination1.nativeElement;
            requiredElement = document.getElementById('txtContamination1');
            break;

          case "DataList":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement=this.datalistContamination1.nativeElement;
            requiredElement = document.getElementById('datalistContamination1');
          break;
        }
        break;
      case "Contamination2":
        switch (whichType) {
          case "Input":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement = this.txtContamination2.nativeElement;
            requiredElement = document.getElementById('txtContamination2');
          break;

          case "DataList":
            //Modified by JW(2022-10-05): Contamination page, modified html and component.ts after downgrade to Angular v12
            //requiredElement=this.datalistContamination2.nativeElement;
            requiredElement = document.getElementById('datalistContamination2');
          break;
        }
      break;
      case 'OtherContamination':
        switch (whichType) {
          case "Input":
            //requiredElement = this.txtOtherGas.nativeElement;
            requiredElement = document.getElementById('txtOtherGas');
          break;

          case "DataList":
            //requiredElement=this.datalistOtherGas.nativeElement;
            requiredElement = document.getElementById('datalistOtherGas');
          break;
        }
      break;
    }

    return requiredElement;
  }

  //Modified by JW(2022-10-05): filter dropdown list based on input entries-start
  search() {
    let inputtext = this.txtApplication.nativeElement.value;
    inputtext = inputtext.toLowerCase();
    if (inputtext !== '') {
      if (this.applicationList.length > 0) {
        let tempAppList:any = [];
        for (let i=0; i<this.applicationList.length; i++) {
          let tempAppName = this.applicationList[i].name;
          tempAppName = tempAppName.toLowerCase();
          if (tempAppName.includes(inputtext)) {
            tempAppList.push(this.applicationList[i]);
          }
        }
        this.applicationList = tempAppList;
      }
    }else {
      //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
      //this.applicationList = this.AllDDLList.ApplicationChemicalList;
      this.applicationList = this.sharedService.ApplicationChemicalList;
      //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END
    
    }
    this.onFocusEvent("Application",0);
  }
  //Modified by JW(2022-10-05): filter dropdown list based on input entries-end

  formatNumber(item, input, pIndex){
    let inputvalue=input;
    let output = this.sharedService.formatValue(input, true);

    switch(item) {
      case "Concentration":
        this.contamination.gasDetails[pIndex].concentrationValue = output;
        break;

      case "OtherGasDensity":
        this.OtherGasDensity = output;
        break;

      case "OtherGasMolWeight":
        this.OtherGasMolWeight = output;
        break;

      case "OtherGasBoilingPoint":
        this.OtherGasBoilingPoint = output;
        break;

      case "OtherGasRefractiveIndex":
        this.OtherGasRefractiveIndex = output;
        break;

      case "OtherGasVapourPA":
        this.OtherGasVapourPressure = output;
        break;

      default:
        this.contamination[item] = output;
        break;
    }

    // if (item == 'Concentration') {
    //   this.contamination.gasDetails[pIndex] = output;
    // } else {
    //   this.contamination[item] = output;
    // }
  }

  selectApplication (item:any) {
    let selectedAppId = item.id;
    this.contaminationList = [];
    this.chemicalListBasedOnSelectedApp = [];
    //this.contaminationList = item.chemicalList;
    //Modified by JW(2022-10-05): filter dropdown list based on input entries-start
    //this.chemicalListBasedOnSelectedApp = item.chemicalList;
    //this.contaminationList1 = item.chemicalList;
    //this.contaminationList2 = item.chemicalList;
    //this.contaminationList3 = item.chemicalList;
    //Modified by JW(2022-10-05): filter dropdown list based on input entries-end

    //For this.contaminationList
    for (var i=0;i<item.chemicalList.length;i++) {
      let tmpGas = {
        ChemicalID: item.chemicalList[i].ChemicalID,
        substance: item.chemicalList[i].substance
      }
      this.contaminationList.push(tmpGas);
    }

    //For this.chemicalListBasedOnSelectedApp
    for (var i=0;i<item.chemicalList.length;i++) {
      let tmpGas = {
        ChemicalID: item.chemicalList[i].ChemicalID,
        substance: item.chemicalList[i].substance
      }
      this.chemicalListBasedOnSelectedApp.push(tmpGas);
    }

    //Loop all selected gas and if chemical id not in new contaminationlist then remove
    var GasToRemove = [];
    var thisGasToRemove = false;
    for (var x=0;x<this.contamination.gasDetails.length;x++) {
      thisGasToRemove = false;
      for (var y=0;y<this.contaminationList.length;y++) {
        if (this.contamination.gasDetails[x].chemicalID == this.contaminationList[y].ChemicalID) {
          thisGasToRemove = false;
          break;
        } else {
          thisGasToRemove = true;
        }
      }
      if (thisGasToRemove) {
        GasToRemove.push(x);
      }
    }

    if (GasToRemove.length > 0) {
      GasToRemove.sort().reverse();
      for (var x=0;x<GasToRemove.length;x++) {
        this.removeFromGasDetails(GasToRemove[x]);
      }
    }
  }
  
  selectContaminationType (item:any, pIndex:number) {
    //Modified by PP(2023-02-16) : Block user from selecting same gas - START
    var CanContinue = false;

    if (item.substance != undefined) {
      for (let i=0 ; i< this.contamination.gasDetails.length; i++) {
        CanContinue = true;
        if (this.contamination.gasDetails[i].chemicalID > 0) {         
          if (this.contamination.gasDetails[i].chemicalID != item.ChemicalID && i == pIndex) {            
            this.removeGasFromSolutionsDetails(this.contamination.gasDetails[i].chemicalID, this.contamination.gasDetails[i].contaminationType, this.contamination.gasDetails[i].concentrationValue);
          }
        }        
      }
    } else {
      CanContinue = false; //To prevent concentration value from calculating after load. Load record may have their own conc value
    }

    if (CanContinue) { //Modified by PP(2023-02-16) : Block user from selecting same gas - END
      if (item.ChemicalID == 0 && item.substance == 'Others') {
        this.sharedService.currentIndexForOtherGas = pIndex;
        this.clearFormOthers();
        this.ToOpenOthersPopUp();
      } else {
        //Get Selected Chemical information
        let ChemInfo = this.sharedService.getChemInfo(item.ChemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
        
        switch (this.selectedConcUnit) {
          case "ppb":
            this.sharedService.ppbForMgm3 = false;
            //pplim: trigger when select type
            this.startCalculateConcentration(1, "ppb", ChemInfo, item, pIndex, false);
            break;
  
          case "mg/m³":
            this.sharedService.ppbForMgm3 = true;
            this.startCalculateConcentration(1, "ppb", ChemInfo, item, pIndex, false);
            this.sharedService.ppbForMgm3 = false;
            
            this.startCalculateConcentration(this.contamination.gasDetails[pIndex].concentrationValue, "mg/m³", ChemInfo, item, pIndex, false);      
            
            break;
        } 
        //this.startCalculateConcentration(1, ChemInfo, item, pIndex, false);
      }     
    } //Modified by PP(2023-02-16) : Block user from selecting same gas             
  }

  selectContaminationTypeForBlockSameGas (item:any, pIndex:number) {
    //Modified by PP(2023-02-16) : Block user from selecting same gas - START
    var CanContinue = false;

    if (item.substance != undefined) {
      for (let i=0 ; i< this.contamination.gasDetails.length; i++) {
        if (this.contamination.gasDetails[i].chemicalID == item.ChemicalID && i != pIndex) {
          if (this.contamination.gasDetails[i].chemicalID === 0) { //Other Chemical
            CanContinue = true;
            break;
          } else { //Normal Gas        
            CanContinue = false;
            this.toastr.warning(item.substance + ' : This gas has been selected.', '');

            //Modified by PP(2023-05-19) : Bugs
            //Gas 1 : Acetalhyde, Gas 2: 1 Methoxy,  Gas 3 : Acetic Acid. Change Gas 3 to Acetalhyde. Must remove Acetic Acid in solutions and contamination as well
            this.removeFromGasDetails(pIndex);
            
            //e.preventDefault();
            //item.ChemicalID = 0;
            //item.substance = "";        
            break;
          }   
        } else {
          CanContinue = true;

          //Modified by PP(2023-05-22) : If change gas - START
          if (this.contamination.gasDetails[i].chemicalID > 0) {
            if (this.contamination.gasDetails[i].chemicalID != item.ChemicalID && i == pIndex) {
              this.removeGasFromSolutionsDetails(this.contamination.gasDetails[i].chemicalID, this.contamination.gasDetails[i].contaminationType, this.contamination.gasDetails[i].concentrationValue);
            }
          }          
          //Modified by PP(2023-05-22) : If change gas - END
        }
      }
    } else {
      CanContinue = false; //To prevent concentration value from calculating after load. Load record may have their own conc value
    }

    if (CanContinue) { //Modified by PP(2023-02-16) : Block user from selecting same gas - END
      if (item.ChemicalID == 0 && item.substance == 'Others') {
        this.sharedService.currentIndexForOtherGas = pIndex;
        this.clearFormOthers();
        this.ToOpenOthersPopUp();
      } else {
        //Get Selected Chemical information
        let ChemInfo = this.sharedService.getChemInfo(item.ChemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
        
        switch (this.selectedConcUnit) {
          case "ppb":
            this.sharedService.ppbForMgm3 = false;
            this.startCalculateConcentration(1, "ppb", ChemInfo, item, pIndex, false);
            break;
  
          case "mg/m³":
            this.sharedService.ppbForMgm3 = true;
            this.startCalculateConcentration(1, "ppb", ChemInfo, item, pIndex, false);
            this.sharedService.ppbForMgm3 = false;
            
            this.startCalculateConcentration(this.contamination.gasDetails[pIndex].concentrationValue, "mg/m³", ChemInfo, item, pIndex, false);      
            
            break;
        } 
        //this.startCalculateConcentration(1, ChemInfo, item, pIndex, false);
      }     
    } //Modified by PP(2023-02-16) : Block user from selecting same gas             
  }

  startCalculateConcentration(pConcValue:any, pConcUnit:any, pChemInfo:any, pItem:any, pIndex:number, isOtherGas:boolean) {
    var CalculatedConcValue:any;

    // If US unit
    var returnValueVPa = undefined;
    var tmpBoiling_point = undefined;

    if (this.projectService.projectdetails.projectInfo.unitId == 2) {
      //Boiling Point
      tmpBoiling_point = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(pChemInfo.boilingPoint, this.NumberFormat), 'US');
      pChemInfo.boilingPoint = tmpBoiling_point.toFixed(2); //pplim 20251002

      //Vapour Pressure
      // Not converttemperature. should be cld2.0 bugs returnValueVPa = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat), 'US');
      returnValueVPa = this.calculateService.ConvertVapourPa(this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat), 'US');
      pChemInfo.vapourPressureValue = returnValueVPa.toFixed(2);
    } else {
      returnValueVPa = this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat); //27.9 while boiling_point = 56.2 / unitId = 1
    }

    //Calculate Concentration Value
    CalculatedConcValue = this.calculateService.CalculateConcentration(pConcValue, pConcUnit, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.contamination.temperature, this.sharedService.convertLocaletoNumber(pChemInfo.molecularWeight, this.NumberFormat));

    if (isOtherGas) {
      this.contamination.gasDetails[pIndex].chemicalID = pChemInfo.otherContaminantID;
      //this.contamination.gasDetails[pIndex].contaminationType = pChemInfo.contamination_type;
    } else {
      switch(pIndex) {
        case 0:
          this.contaminationType1 = pChemInfo.contamination_type;
          break;

        case 1:
          this.contaminationType2 = pChemInfo.contamination_type;
          break;

        case 2:
          this.contaminationType3 = pChemInfo.contamination_type;
          break;
      }

      this.contamination.gasDetails[pIndex].chemicalID = pItem.ChemicalID;
      this.contamination.gasDetails[pIndex].contaminationType = pChemInfo.contamination_type;
    }

    this.contamination.gasDetails[pIndex].concentrationValue = this.sharedService.formatValue(CalculatedConcValue, true);

  //Get Concentration Value for Alternate value - START
  switch (pConcUnit) {
    case "ppb":
      if (this.sharedService.ppbForMgm3 === true) {
        this.contamination.gasDetails[pIndex].altConcUnit = "ppb";
        this.contamination.gasDetails[pIndex].altConcValue = this.sharedService.formatValue(CalculatedConcValue, true);
      } else {
        this.contamination.gasDetails[pIndex].altConcUnit = "mg/m³";
        this.contamination.gasDetails[pIndex].altConcValue = this.sharedService.formatValue(1, true); 
      }
        
      break;
    case "mg/m³":        
      break;
  }
  //Get Concentration Value for Alternate value - END

    this.contamination.gasDetails[pIndex].moreInformation.chemicalFormula = pChemInfo.chemicalFormula;
    this.contamination.gasDetails[pIndex].moreInformation.vapourPressureValue = this.sharedService.formatValue(pChemInfo.vapourPressureValue, true);
    this.contamination.gasDetails[pIndex].moreInformation.molecularWeight = this.sharedService.formatValue(pChemInfo.molecularWeight, true);
    this.contamination.gasDetails[pIndex].moreInformation.boilingPoint = this.sharedService.formatValue(pChemInfo.boilingPoint, true);
    this.contamination.gasDetails[pIndex].moreInformation.casNo = pChemInfo.cas_no;

    //Chemical Warning
    if (pChemInfo.chemical_warning != '') {
      this.contamination.gasDetails[pIndex].gasWarningDetail = pChemInfo.chemical_warning;
    }
    switch(pIndex) {
      case 0:
        if (pChemInfo.chemical_warning != '') {
          let spanSection: any;
          switch(pChemInfo.gasWarningColor) {
            case 1:
              spanSection = document.getElementById('spnGasWarningColor0');
              spanSection.style.color = 'red';

              spanSection = document.getElementById('spnGasWarningDetColor0');
              spanSection.style.color = 'red';
              break;
            default:
              spanSection = document.getElementById('spnGasWarningColor0');
              spanSection.style.color = 'blue';

              spanSection = document.getElementById('spnGasWarningDetColor0');
              spanSection.style.color = 'blue';
              break;
          }
          let div = document.getElementById('divGasWarning0');
          div.style.display = 'block';
        } else {
          let div = document.getElementById('divGasWarning0');
          div.style.display = 'none';
        }
        break;

      case 1:
        if (pChemInfo.chemical_warning != '') {
          let spanSection: any;
          switch(pChemInfo.gasWarningColor) {
            case 1:
              spanSection = document.getElementById('spnGasWarningColor1');
              spanSection.style.color = 'red';

              spanSection = document.getElementById('spnGasWarningDetColor1');
              spanSection.style.color = 'red';
              break;
            default:
              spanSection = document.getElementById('spnGasWarningColor1');
              spanSection.style.color = 'blue';

              spanSection = document.getElementById('spnGasWarningDetColor1');
              spanSection.style.color = 'blue';
              break;
          }
          let div = document.getElementById('divGasWarning1');
          div.style.display = 'block';
        } else {
          let div = document.getElementById('divGasWarning1');
          div.style.display = 'none';
        }
        break;
      case 2:
        if (pChemInfo.chemical_warning != '') {
          let spanSection: any;
          switch(pChemInfo.gasWarningColor) {
            case 1:
              spanSection = document.getElementById('spnGasWarningColor2');
              spanSection.style.color = 'red';

              spanSection = document.getElementById('spnGasWarningDetColor2');
              spanSection.style.color = 'red';
              break;
            default:
              spanSection = document.getElementById('spnGasWarningColor2');
              spanSection.style.color = 'blue';

              spanSection = document.getElementById('spnGasWarningDetColor2');
              spanSection.style.color = 'blue';
              break;
          }
          let div = document.getElementById('divGasWarning2');
          div.style.display = 'block';
        } else {
          let div = document.getElementById('divGasWarning2');
          div.style.display = 'none';
        }
        break;
    }
  }

  ToOpenOthersPopUp() {
    this.modalService.open(this.othersGasModal, {ariaLabelledBy: 'modal-basic-title',
    centered: true,
    backdrop: 'static'}).result.then((result) => {

    }, (reason) => {
    this.closeResult = `Dismissed`;
    });
  }

  //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
  /*getChemInfo(pChemID: number) {
    var chemInfo: any;
    for (var x=0;x<this.AllDDLList.ApplicationContaminationFromServer.AMCChemical.length;x++) {
      if (pChemID == this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID) {
        chemInfo = {
          contamination_type : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Substance,
          chemical_id : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID,
          chemicalFormula : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Formula,
          vapourPressureValue : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Vp,
          molecularWeight : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Mw,
          boilingPoint : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Tbp,
          cas_no : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].CasNo,
          density : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].dL,
          refractiveIndex : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].RI,
          chemical_warning : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalWarning,
          gasWarningColor : parseInt(this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Importancy)
        }
        break;
      }
    }
    return chemInfo
  }
  */
//Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END
  
  detectKeyChanges(WhichItem, pIndex) {
    switch(WhichItem) {
      case "airflow":
        //this.formatNumber(WhichItem, parseFloat(this.contamination.airflow), pIndex);
        this.formatNumber(WhichItem, this.sharedService.convertLocaletoNumber(this.contamination.airflow, this.NumberFormat), pIndex);      
        break;
      case "temperature":
        this.formatNumber(WhichItem, parseFloat(this.contamination.temperature), pIndex);
        break;
      case "relativeHumidity":
        this.formatNumber(WhichItem, parseFloat(this.contamination.relativeHumidity), pIndex);
        break;
      case "Concentration":
        this.formatNumber(WhichItem, parseFloat(this.contamination.gasDetails[pIndex].concentrationValue), pIndex);

        //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - START
        var currentConcValue = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[pIndex].concentrationValue, this.NumberFormat);
        var molecularWt = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[pIndex].moreInformation.molecularWeight, this.NumberFormat);
        this.updateAltConcValue(pIndex, currentConcValue, molecularWt);
        //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - END

        this.updateNewConcentrationToSolutions(pIndex, this.contamination.gasDetails[pIndex].concentrationValue);
        break;
      case "OtherGasChemFormula":
        this.prepareToSaveOtherGas();
        break;
      case "OtherGasDensity":
        this.formatNumber(WhichItem,this.OtherGasDensity, pIndex);
        this.prepareToSaveOtherGas();
        break;
      case "OtherGasMolWeight":
        this.formatNumber(WhichItem,this.OtherGasMolWeight, pIndex);
        this.prepareToSaveOtherGas();
        break;
      case "OtherGasBoilingPoint":
        this.formatNumber(WhichItem,this.OtherGasBoilingPoint, pIndex);
        this.prepareToSaveOtherGas();
        break;
      case "OtherGasRefractiveIndex":
        this.formatNumber(WhichItem,this.OtherGasRefractiveIndex, pIndex);
        this.prepareToSaveOtherGas();
        break;
      case "OtherGasVapourPA":
        this.formatNumber(WhichItem,this.OtherGasVapourPressure, pIndex);
        this.prepareToSaveOtherGas();
        break;
    }

    //Trigger Calculation here
    this.triggerCalculation();
  }

  addContamination() {
    if (this.contamination.gasDetails.length > 2) {

    } else {
      this.inum = this.contamination.gasDetails.length + 1;
      var newGasDetails = this.projectService.getGasDetailsEmptyvalueStructure();
      newGasDetails.index = this.contamination.gasDetails.length;
      this.contamination.gasDetails.push(newGasDetails);
      this.contaminationChanged = true;
      if (this.contamination.gasDetails.length === 3 && this.AddContaminationInfo) {        
        this.showHideInfoToggle('AddContaminationInfo');
      }
    }
  }

  setPoppers() {
    let AddContaminationInfoBtn = document.querySelector('#AddContaminationInfoBtn');
    let AddContaminationInfo = document.getElementById('divAddContaminationInfo');

    this.createPop(AddContaminationInfoBtn, AddContaminationInfo);
  }

  showHideInfoToggle(event) {
    let AddContaminationInfo = document.getElementById('divAddContaminationInfo');

    if (!this.AddContaminationInfo && event === 'AddContaminationInfo') {
      AddContaminationInfo.setAttribute('data-show', '');
      this.AddContaminationInfo = true;
    } else if (this.AddContaminationInfo && event === 'AddContaminationInfo') {
      AddContaminationInfo.removeAttribute('data-show');
      this.AddContaminationInfo = false;
    }
  }

  createPop(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [0, 8],
           },
         },
      ],
    });
  }

  moreInfo(pIndex:number) {
    switch(pIndex) {
      case 0:
        if (this.displayTypeForMoreInfo1 == "" || this.displayTypeForMoreInfo1 == "More Information") {
          let div = document.getElementById('divMoreInfoForGas0');
          div.style.display = 'block';
          this.displayTypeForMoreInfo1 = "Collapse";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "Collapse";
        } else {
          let div = document.getElementById('divMoreInfoForGas0');
          div.style.display = 'none';
          this.displayTypeForMoreInfo1 = "More Information";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "More Information";
        }
        break;

      case 1:
        if (this.displayTypeForMoreInfo2 == "" || this.displayTypeForMoreInfo2 == "More Information") {
          let div = document.getElementById('divMoreInfoForGas1');
          div.style.display = 'block';
          this.displayTypeForMoreInfo2 = "Collapse";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "Collapse";
        } else {
          let div = document.getElementById('divMoreInfoForGas1');
          div.style.display = 'none';
          this.displayTypeForMoreInfo2 = "More Information";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "More Information";
        }
        break;

      case 2:
        if (this.displayTypeForMoreInfo3 == "" || this.displayTypeForMoreInfo3 == "More Information") {
          let div = document.getElementById('divMoreInfoForGas2');
          div.style.display = 'block';
          this.displayTypeForMoreInfo3 = "Collapse";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "Collapse";
        } else {
          let div = document.getElementById('divMoreInfoForGas2');
          div.style.display = 'none';
          this.displayTypeForMoreInfo3 = "More Information";
          this.contamination.gasDetails[pIndex].displayTypeForMoreInfo = "More Information";
        }
        break;
    }
  }

  removeFromGasDetails(pIndex) {
    this.contaminationType1 = "";
    this.contaminationType2 = "";
    this.contaminationType3 = "";

    this.contamination.gasDetails.splice(pIndex, 1);

    //Reindex
    for (var x=0;x<this.contamination.gasDetails.length;x++) {
      this.contamination.gasDetails[x].index = x;

      switch(x) {
        case 0:
          this.contaminationType1 = this.contamination.gasDetails[x].contaminationType;
          break;
        case 1:
          this.contaminationType2 = this.contamination.gasDetails[x].contaminationType;
          break;
        case 2:
          this.contaminationType3 = this.contamination.gasDetails[x].contaminationType;
          break;
      }
    }

    //Remove from Solution Details
    for (var p=0;p<this.projectService.projectdetails.solutions.length;p++) {
      for (var q=0;q<this.projectService.projectdetails.solutions[p].solutionDetails.length;q++) {
        var removedSolutionDetails = false;
        if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.length>1) {
          //Remove only this gas
          for (var r=0;r<this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.length;r++) {
            var gasExist = false;
            for (var s=0;s<this.contamination.gasDetails.length;s++) {             
              if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[r].chemicalID == this.contamination.gasDetails[s].chemicalID) {
                gasExist = true;
                break;
              }             
            }
            if (!gasExist) {
              this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.splice(r, 1);
              r = r - 1;
            }                
          }
          
        } else { 
          if (this.projectService.projectdetails.solutions[p].solutionDetails.length > 1) {
            var gasExist = false;
            for (var s=0;s<this.contamination.gasDetails.length;s++) {
              if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[0].chemicalID == this.contamination.gasDetails[s].chemicalID) {
                gasExist = true;
                break;
              }
            }
            if (!gasExist) {
              removedSolutionDetails = true;
              this.projectService.projectdetails.solutions[p].solutionDetails.splice(q, 1);
              if (q === 0) {
                q = 0;
              } else {
                q = q - 1;
              }             
            }
          }

          //Only 1 Gas and only 1 solutiondetails then remove this solution        
          if (this.projectService.projectdetails.solutions[p].solutionDetails.length == 1 && removedSolutionDetails === false) {
            var gasExist = false;
            for (var s=0;s<this.contamination.gasDetails.length;s++) {
              if (this.projectService.projectdetails.solutions[p].solutionDetails[0].combinationGas[0].chemicalID == this.contamination.gasDetails[s].chemicalID) {
                gasExist = true;
                break;
              }
            }
        
            if (!gasExist) {
              //this.projectService.projectdetails.solutions[p].solutionDetails=[];
              this.projectService.projectdetails.solutions.splice(p, 1);
              if (p === 0) {
                p = 0;
                break; //Modified by PP(2023-05-19) : Bugs
              } else {
                p = p - 1;
              }              
            }           
          }          
        }
      }

      //Reindex Solution Details
      if (this.projectService.projectdetails.solutions.length > 0) { //Modified by PP(2023-05-19) : Bugs
        for (var q=0;q<this.projectService.projectdetails.solutions[p].solutionDetails.length;q++) {
          this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationID = q + 1;      
        }
      } //Modified by PP(2023-05-19) : Bugs    
    }

    //Reindex Solutions
    for (var p=0;p<this.projectService.projectdetails.solutions.length;p++) { 
      let oldSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID;          
      this.projectService.projectdetails.solutions[p].solutionID = p+1;
      let newSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID; 
   
      if (this.projectService.projectdetails.solutions[p].solutionName === oldSolName) {
        this.projectService.projectdetails.solutions[p].solutionName = newSolName;
      }
    }

    this.contaminationChanged = true;

    if (this.contamination.gasDetails.length == 0) {
      this.addContamination();
    }

  }

  forceClose() {

  }

  selectOtherGas(item:any) {
    for (var x=0;x<this.otherGassesList.length;x++) {
      if (this.otherGassesList[x].substance == item) {
        this.OtherGasID = this.otherGassesList[x].ID;
        this.OtherGasName = this.otherGassesList[x].substance;
        this.OtherGasChemFormula = this.otherGassesList[x].formula;

        this.OtherGasDensity = this.sharedService.formatValue(this.otherGassesList[x].dl, true);
        this.OtherGasMolWeight = this.sharedService.formatValue(this.otherGassesList[x].mw, true);
        this.OtherGasBoilingPoint = this.sharedService.formatValue(this.otherGassesList[x].tbp, true);
        this.OtherGasRefractiveIndex = this.sharedService.formatValue(this.otherGassesList[x].ri, true);
        this.OtherGasVapourPressure = this.sharedService.formatValue(this.otherGassesList[x].vp, true);
      }
    }
  }

  assignDetailsAfterConfirmOtherGasSelection() {    
    var x = this.sharedService.currentIndexForOtherGas;
    let input:any;
    switch(x) {
      case 0:
        this.contaminationType1 = "Others - " + this.OtherGasName;
        input = document.getElementById('txtContamination0');
        input.value = "Others - " + this.OtherGasName;
        break;

      case 1:
        this.contaminationType2 = "Others - " + this.OtherGasName;
        input = document.getElementById('txtContamination1');
        input.value = "Others - " + this.OtherGasName;
        break;

      case 2:
        this.contaminationType3 = "Others - " + this.OtherGasName;
        input = document.getElementById('txtContamination2');
        input.value = "Others - " + this.OtherGasName;
        break;
    }

    this.contamination.gasDetails[x].otherGas = true;
    //this.contamination.gasDetails[x].contaminationType = "Others - " + this.OtherGasName;
    this.contamination.gasDetails[x].contaminationType = "Others";

    this.contamination.gasDetails[x].otherGasDetails.boilingPoint = this.OtherGasBoilingPoint;
    this.contamination.gasDetails[x].otherGasDetails.chemicalFormula = this.OtherGasChemFormula;
    this.contamination.gasDetails[x].otherGasDetails.density = this.OtherGasDensity;
    this.contamination.gasDetails[x].otherGasDetails.molecularWeight = this.OtherGasMolWeight;
    this.contamination.gasDetails[x].otherGasDetails.otherContaminantID = this.OtherGasID;
    this.contamination.gasDetails[x].otherGasDetails.otherContaminantName = this.OtherGasName;
    this.contamination.gasDetails[x].otherGasDetails.refractiveIndex = this.OtherGasRefractiveIndex;
    this.contamination.gasDetails[x].otherGasDetails.vapourPressureValue = this.OtherGasVapourPressure;

    this.modalService.dismissAll();

    var item: any;
    item = {
      ChemicalID: this.contamination.gasDetails[x].chemicalID,
      substance: this.contamination.gasDetails[x].contaminationType
    }

    switch (this.selectedConcUnit) {
      case "ppb":
        this.startCalculateConcentration(1, "ppb", this.contamination.gasDetails[x].otherGasDetails, item, this.sharedService.currentIndexForOtherGas, true);
        break;

      case "mg/m³":
        this.startCalculateConcentration(1, "ppb",this.contamination.gasDetails[x].otherGasDetails, item, this.sharedService.currentIndexForOtherGas, true);
        this.startCalculateConcentration(this.contamination.gasDetails[x].concentrationValue, "mg/m³", this.contamination.gasDetails[x].otherGasDetails, item, this.sharedService.currentIndexForOtherGas, true);
    }
    //this.startCalculateConcentration(1, this.contamination.gasDetails[x].otherGasDetails, item, this.sharedService.currentIndexForOtherGas, true);
  }

  confirmOtherGasSelection() {
    this.assignDetailsAfterConfirmOtherGasSelection();
    this.triggerSaveOtherGas();   

    if (this.OtherGasID === 0) { //New Gas then save
      //this.triggerSaveOtherGas(true);      
    } else {
      
    }
  }
  
  openFormOthers(pIndex:number) {
    this.sharedService.currentIndexForOtherGas = pIndex;
    this.clearFormOthers();

    //Assign Current OtherGas Details into Form
    if (this.contamination.gasDetails[pIndex].otherGas) {
      this.OtherGasID = this.contamination.gasDetails[pIndex].otherGasDetails.otherContaminantID;
      this.OtherGasName = this.contamination.gasDetails[pIndex].otherGasDetails.otherContaminantName;
      this.OtherGasChemFormula = this.contamination.gasDetails[pIndex].otherGasDetails.chemicalFormula;
      this.OtherGasDensity = this.contamination.gasDetails[pIndex].otherGasDetails.density;
      this.OtherGasMolWeight = this.contamination.gasDetails[pIndex].otherGasDetails.molecularWeight;
      this.OtherGasBoilingPoint = this.contamination.gasDetails[pIndex].otherGasDetails.boilingPoint;
      this.OtherGasRefractiveIndex = this.contamination.gasDetails[pIndex].otherGasDetails.refractiveIndex;
      this.OtherGasVapourPressure = this.contamination.gasDetails[pIndex].otherGasDetails.vapourPressureValue;
    }

    this.ToOpenOthersPopUp();
  }

  clearFormOthers() {
    this.OtherGasID = 0;
    this.OtherGasName = '';
    this.OtherGasChemFormula = '';
    this.OtherGasDensity = 0;
    this.OtherGasMolWeight = 0;
    this.OtherGasBoilingPoint = 0;
    this.OtherGasRefractiveIndex = 0;
    this.OtherGasVapourPressure = 0;
  }

  Proceed() {
    this.flag = false;
    var NoChemSelected = false;

    if (this.contamination.gasDetails.length == 0) {
      this.flag = true;
    }

    if(this.flag && this.projectService.valid['contamination'] !== 'Skipped'){
      this.toastr.warning('Please add contamination', '');
    }

    if (!this.flag) {
      if (this.contamination.gasDetails.length > 0) {
        if (this.contamination.gasDetails[0].chemicalID == 0) {
          if (this.contamination.gasDetails[0].contaminationType == '') {
            NoChemSelected = true;
          }        
        }
      }
    }

    if (NoChemSelected) {
      this.flag = true;
      this.toastr.warning('Please select contamination', '');
    }

    else{
      this.projectService.projectdetails['contamination'] = this.contamination;
      this.projectService.valid.contamination = 'Valid';
    }
  }

  next(){
    this.nextStep.emit();
  }

  toggleUnit() {
    if(this.selUnitFromProgSettings === 2){
      this.selAirFlowUnitFromProgSettings = 'CFM';
      this.airFlowUnitlist = this.AllDDLList.US_List.AirFlowUnits;
      this.disableFlag = true;
    }
    else {
      this.airFlowUnitlist = this.AllDDLList.SI_List.AirFlowUnits;
      this.selAirFlowUnitFromProgSettings = 'm³/h';
      this.disableFlag = false;
    }
  }

  triggerDoneFromProgSettings() {    
    var NeedToPostData = false; //Modified by PP(2023-02-28) : Save into user's table    

    //Check Airflow Unit changed
    if (this.selAirFlowUnitFromProgSettings != this.contamination.airflowUnit) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table 
      //Find Previous Unit
      var previousUnit = "";
      switch (this.contamination.airflowUnit) {
        case "m³/h":
          previousUnit = "m³/h";
          break;
        case "CFM":
          previousUnit = "CFM";
          break;
        case "m³/s":
          previousUnit = "m³/s";
          break;
        case "L/s":
          previousUnit = "L/s";
          break;
      }

      let convertedAirflow = this.calculateService.ConvertAirFlow(this.sharedService.convertLocaletoNumber(this.contamination.airflow, this.NumberFormat), previousUnit, this.selAirFlowUnitFromProgSettings);
      this.contamination.airflow = this.sharedService.formatValue(convertedAirflow, true);

      switch (this.selAirFlowUnitFromProgSettings) {
        case "m³/h":
          this.contamination.airflowUnit = "m³/h";
          break;
        case "CFM":
          this.contamination.airflowUnit = "CFM";
          break;
        case "m³/s":
          this.contamination.airflowUnit = "m³/s";
          break;
        case "L/s":
          this.contamination.airflowUnit = "L/s";
          break;
      }
    }

    //Check Concentration Unit changed
    if (this.selConcUnitFromProgSettings != this.selectedConcUnit) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table 
      
      switch (this.selConcUnitFromProgSettings) {
        case "ppb":
          this.selectedConcUnit = "ppb";
          this.projectService.projectdetails.projectInfo.concUnit = "ppb";
          break;
        case "mg/m³":
          this.selectedConcUnit = "mg/m³";
          this.projectService.projectdetails.projectInfo.concUnit = "mg/m³";
          break;
      }

      //Trigger Concentration Calculation
      var ChemInfo:any;
      var item:any;
      for (var x=0;x<this.contamination.gasDetails.length;x++) {
        if (this.contamination.gasDetails[x].chemicalID > 0 && this.contamination.gasDetails[x].contaminationType != "") {
          if (this.contamination.gasDetails[x].otherGas) {
            ChemInfo = this.contamination.gasDetails[x].otherGasDetails;
            item = {
              ChemicalID: this.contamination.gasDetails[x].chemicalID,
              substance: this.contamination.gasDetails[x].contaminationType
            }
          } else {
            ChemInfo = this.sharedService.getChemInfo(this.contamination.gasDetails[x].chemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
            item = {
              ChemicalID: this.contamination.gasDetails[x].chemicalID,
              substance: this.contamination.gasDetails[x].contaminationType
            }
          }
          this.startCalculateConcentration(this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].concentrationValue, this.NumberFormat), this.selectedConcUnit, ChemInfo, item, x, this.contamination.gasDetails[x].otherGas);

          //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - START
          var currentConcValue = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].concentrationValue, this.NumberFormat);
          var molecularWt = this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].moreInformation.molecularWeight, this.NumberFormat);
          this.updateAltConcValue(x, currentConcValue, molecularWt);
          //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - END

          this.updateNewConcentrationToSolutions(x, this.contamination.gasDetails[x].concentrationValue);
        }
      }
    }

    //Check Metrics Unit changed       
    if (this.selUnitFromProgSettings != this.projectService.projectdetails.projectInfo.unitId) {
      NeedToPostData = true; //Modified by PP(2023-02-28) : Save into user's table 
      var PreviousUnit = "";      
      switch(this.projectService.projectdetails.projectInfo.unitId) {
        case 1:
          PreviousUnit = "SI";
          break;
        case 2:
          PreviousUnit = "US";
          break;
      }

      var unitToChange = "";
      switch (this.selUnitFromProgSettings) {
        case 1:
          unitToChange = "SI";
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
          this.projectService.projectdetails.projectInfo.unitId = 1;
          break;

        case 2:
          unitToChange = "US";
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
          this.projectService.projectdetails.projectInfo.unitId = 2;
          break;
      }

      //Airflow - will be converted at the beginning of this function

      //Temperature
      var newTemperatureValue = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(this.contamination.temperature, this.NumberFormat), unitToChange);
      this.contamination.temperature = this.sharedService.formatValue(newTemperatureValue, true);

      for (var x=0;x<this.contamination.gasDetails.length;x++) {
        //Vapour Pressure
        var newVapourPressureValue = this.calculateService.ConvertVapourPa(this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].moreInformation.vapourPressureValue, this.NumberFormat), unitToChange);
        this.contamination.gasDetails[x].moreInformation.vapourPressureValue = this.sharedService.formatValue(newVapourPressureValue, true);

        //Boiling Point
        var newBoilingPointValue = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(this.contamination.gasDetails[x].moreInformation.boilingPoint, this.NumberFormat), unitToChange);
        this.contamination.gasDetails[x].moreInformation.boilingPoint = this.sharedService.formatValue(newBoilingPointValue, true);
      }

      //To convert Solutions page
      for (var i=0; i<this.projectService.projectdetails.solutions.length; i++) {
        for (var j=0; j<this.projectService.projectdetails.solutions[i].solutionDetails.length; j++) {
          //Convert Effective Media Weight
          var newEffMediaWeight = this.calculateService.ConvertKgToPounds(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.effectiveMediaWeight, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.effectiveMediaWeight = this.sharedService.formatValue(newEffMediaWeight, true);

          //Convert Total Weight
          var newTotalWeight = this.calculateService.ConvertKgToPounds(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.totalWeight, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.totalWeight = this.sharedService.formatValue(newTotalWeight, true);
          
          //Convert Front Velocity
          var newFrontVelocity = this.calculateService.ConvertFrontVelocity(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.frontVelocity, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].moreInformation.frontVelocity = this.sharedService.formatValue(newFrontVelocity, true);
 
          //Convert Filter Sizes
          var newDepth = this.calculateService.ConvertMediaSize(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.depth, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.depth = this.sharedService.formatValue(newDepth, true);

          var newHeight = this.calculateService.ConvertMediaSize(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.height, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.height = this.sharedService.formatValue(newHeight, true);

          var newLength = this.calculateService.ConvertMediaSize(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.length, this.NumberFormat), unitToChange);
          this.projectService.projectdetails.solutions[i].solutionDetails[j].customMediaSize.length = this.sharedService.formatValue(newLength, true);
        }
      } 
    }

    //Modified by PP(2023-02-28) : Save into user's table - START
    if (NeedToPostData) {
      var selConcUnitIDFromProgSettings = 0;
      var selConcUnitFromProgSettings = ""
      switch (this.selConcUnitFromProgSettings) {
        case "ppb":
          selConcUnitIDFromProgSettings = 1;
          selConcUnitFromProgSettings = "ppb";
        break;
        case "mg/m³":
          selConcUnitIDFromProgSettings = 2;
          selConcUnitFromProgSettings = "mg/m³";
        break;
      }

      var selUserUnitFromProgSettings = "";
      var selUserUnitIDFromProgSettings = 0
      switch (this.selUnitFromProgSettings) {
        case 1:
          selUserUnitFromProgSettings = "SI";
          selUserUnitIDFromProgSettings = 1;
          break;
        case 2:
          selUserUnitFromProgSettings = "US";
          selUserUnitIDFromProgSettings = 2;
          break;
      }

      var selAirflowUnitFromProgSettings = "";
      switch (this.selAirFlowUnitFromProgSettings) {
        case "m³/h":
          selAirflowUnitFromProgSettings = "m³/h";
          break;
        case "CFM":
          selAirflowUnitFromProgSettings = "CFM";
          break;
        case "m³/s":
          selAirflowUnitFromProgSettings = "m³/s";
          break;
        case "L/s":
          selAirflowUnitFromProgSettings = "L/s";
          break;
      }
      this.programSettingsService.postData(this.selUnitFromProgSettings,selConcUnitIDFromProgSettings, this.userInfoService.userData.NumberFormatId, this.selAirFlowUnitFromProgSettings).subscribe(res => {   
        this.userInfoService.userData.AirFlowUnit = selAirflowUnitFromProgSettings;
        this.userInfoService.userData.UserConcUnitId = selConcUnitIDFromProgSettings;
        this.userInfoService.userData.UserConcUnit = selConcUnitFromProgSettings;
        this.userInfoService.userData.UserUnitId = selUserUnitIDFromProgSettings;
        this.userInfoService.userData.UserUnitName = selUserUnitFromProgSettings;
        this.toastr.success('Data successfully inserted', '');

      });
    }
    //Modified by PP(2023-02-28) : Save into user's table - END
  }

  triggerCancelFromProgSettings() {
    //Unit
    if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
      this.selUnitFromProgSettings = 1;
      this.disableFlag=false;
    } else {
      this.selUnitFromProgSettings = 2;
      this.disableFlag=true;
    }

    //Concentration Unit
    switch (this.userInfoService.userData.UserConcUnit) {
      case "ppb":
        this.selectedConcUnit = "ppb";
        this.selConcUnitFromProgSettings = "ppb";
        break;
      case "mg/m³":
        this.selectedConcUnit = "mg/m³";
        this.selConcUnitFromProgSettings = "mg/m³";
        break;
    }

    //Airflow Unit
    switch (this.contamination.airflowUnit) {
      case "m³/h":
        this.selAirFlowUnitFromProgSettings = "m³/h";
        break;
      case "CFM":
        this.selAirFlowUnitFromProgSettings = "CFM";
        break;
      case "m³/s":
        this.selAirFlowUnitFromProgSettings = "m³/s";
        break;
      case "L/s":
        this.selAirFlowUnitFromProgSettings = "L/s";
        break;
    }
  }

  InsertDataIntoEachContaminatinBoxes() {
    for (var x=0;x<this.contamination.gasDetails.length;x++) {
      if (this.contamination.gasDetails[x].contaminationType == 'Others') {
        if (this.contamination.gasDetails[x].otherGas) {
          switch (x) {
            case 0:
              this.contaminationType1 = 'Others - ' + this.contamination.gasDetails[x].otherGasDetails.otherContaminantName;
              break;
            case 1:
              this.contaminationType2 = 'Others - ' + this.contamination.gasDetails[x].otherGasDetails.otherContaminantName;
              break;
            case 2:
              this.contaminationType3 = 'Others - ' + this.contamination.gasDetails[x].otherGasDetails.otherContaminantName;
              break;
          }
        }

      } else { //Normal Gasses
        switch (x) {
          case 0:
            this.contaminationType1 = this.contamination.gasDetails[x].contaminationType;
            break;
          case 1:
            this.contaminationType2 = this.contamination.gasDetails[x].contaminationType;
            break;
          case 2:
            this.contaminationType3 = this.contamination.gasDetails[x].contaminationType;
            break;
        }
      }
    }
  }

  //Modified by JW(2022-10-05): filter dropdown list based on input entries-start
  filterContaminationList (pIndex:number) {
    let inptxt = "";
    switch (pIndex) {
      case 0:
        inptxt = (<HTMLInputElement>document.getElementById('txtContamination0')).value;
        break;
      case 1:
        inptxt = (<HTMLInputElement>document.getElementById('txtContamination1')).value;
        break;
      case 2:
        inptxt = (<HTMLInputElement>document.getElementById('txtContamination2')).value;
        break;
    }
    this.contaminationList = [];
    if (inptxt !== "") {
      inptxt = inptxt.toLowerCase();
      if (this.chemicalListBasedOnSelectedApp.length > 0) {
        let tempChemList:any = [];
        let gasname = "";
        for (let i=0; i<this.chemicalListBasedOnSelectedApp.length; i++) {
          gasname = this.chemicalListBasedOnSelectedApp[i].substance;
          gasname = gasname.toLowerCase();
          if (gasname.includes(inptxt)) {
            tempChemList.push(this.chemicalListBasedOnSelectedApp[i]);
          }
        }
        this.contaminationList = tempChemList;
      }
    }else{
      //this.contaminationList = this.chemicalListBasedOnSelectedApp;
      for (let i=0; i<this.chemicalListBasedOnSelectedApp.length; i++) {
        let tmpGas = {
          ChemicalID: this.chemicalListBasedOnSelectedApp[i].ChemicalID,
          substance: this.chemicalListBasedOnSelectedApp[i].substance
        }
        this.contaminationList.push(tmpGas);
      }
    }
    this.onFocusEvent("Contamination",pIndex);
  }
  //Modified by JW(2022-10-05): filter dropdown list based on input entries-end

  triggerSaveOtherGas(){    
    //this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
    this.sharedService.ServerData = this.CompileDataForSaveOtherGas();
    this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
    this.PrepareToUploadParams(false);
  }

  PrepareToUploadParams(forCalc){
    var dataToUpload = this.sharedService.generateStr();
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res =>{
        if (res){
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass+this.sharedService.TempStringStorageTotalFail!==this.sharedService.TempStringStorageTotalSeq){
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PrepareToUploadParams(forCalc);
          } else {
            if (this.sharedService.TempStringStorageTotalPass===this.sharedService.TempStringStorageTotalSeq){
              if (forCalc) { //For Calculations
                this.ProceedToCalculations();
              } else { //For Save Other Gas
                this.ProceedToSaveOtherGas();              
              }          
            } else {

            }
          }
        } else {
          this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
          this.sharedService.UploadingEntry = false;
          this.sharedService.ServerDataReady = false;
        }
      },
      err =>{
        this.sharedService.UploadingEntry = false;
        this.sharedService.ServerDataReady = false;
      }
    );
  }

  CompileDataForSaveOtherGas() {
    let Data: any = {};
    Data = {
      OtherContaminationID : this.OtherGasID,
      OtherContaminationName : this.OtherGasName,
      ChemicalFormula : this.OtherGasChemFormula,     
      Density : this.sharedService.convertLocaletoNumber(this.OtherGasDensity, this.NumberFormat),
      MolecularWeight : this.sharedService.convertLocaletoNumber(this.OtherGasMolWeight, this.NumberFormat),    
      BoilingPoint : this.sharedService.convertLocaletoNumber(this.OtherGasBoilingPoint, this.NumberFormat),     
      RefractiveIndex : this.sharedService.convertLocaletoNumber(this.OtherGasRefractiveIndex, this.NumberFormat),
      VapourPressureValue : this.sharedService.convertLocaletoNumber(this.OtherGasVapourPressure, this.NumberFormat),    
    };
    return Data;
  }

  prepareToSaveOtherGas() {
    if (this.sharedService.OtherGasIDToSave.length > 0) {
      var idExist = false;
      for (var x=0;x<this.sharedService.OtherGasIDToSave.length;x++) {
        if (this.sharedService.OtherGasIDToSave[x] === this.OtherGasID) {
          idExist = true;
          break;
        }
      }
      if (!idExist) {
        this.sharedService.OtherGasIDToSave.push(this.OtherGasID);
      }
    } else {
      this.sharedService.OtherGasIDToSave.push(this.OtherGasID);
    }
  }

  triggerCalculation(){
    var canCalculate = false;
    if (this.projectService.projectdetails.solutions.length === 1) {
      if (this.projectService.projectdetails.solutions[0].solutionDetails.length > 0) {
        if (this.projectService.projectdetails.solutions[0].solutionDetails[0].molecularID > 0) {
          canCalculate = true;
        }
      } else { //No Solution Details
        canCalculate = false;
      }
    }

    if (this.projectService.projectdetails.solutions.length > 1) {
      canCalculate = true;
    }

    if (canCalculate) {
      this.sharedService.CalculationInProgress = true;
      this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0); //0 = for all
      this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
      this.PrepareToUploadParams(true);
    }
}

  ProceedToCalculations() {
    //this.projectService.PerformMCCLDCalculation(false, 0, false, false).subscribe(data => {
    this.projectService.PerformMCCLDCalculation(false, 0, false, false).subscribe(data => {
      //Modified by PP(2023-10-24): Check for timeout of logincode - START
      // if (data) {
      //   this.sharedService.CalculateMCCLDCompleted = true;

      //   let results={};
      //   results = this.projectService.getSolResultsStructure(data);
      //   this.projectService.projectdetails.results=results;

      //   //this.getMoreInformationForSolutions(data);
      //   this.projectService.getMoreInfoForSolutionDetails();
      // } else {
      //      this.sharedService.CalculateMCCLDCompleted = false;
      // }

      if (data!==null) {
        if (data!==undefined) {

          this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SUCCESS_CALCULATION').subscribe(result => {                       
            if (result) {}
          });

          this.sharedService.CalculateMCCLDCompleted = true;

          let results={};
          results = this.projectService.getSolResultsStructure(data);
          this.projectService.projectdetails.results=results;
  
          //this.getMoreInformationForSolutions(data);
          this.projectService.getMoreInfoForSolutionDetails();
        } else {
          this.sharedService.CalculateMCCLDCompleted = false;
          this.toastr.error("Unable to calculate result. Please try again.", "");
        }
      } else {
        this.sharedService.redirectToLoginPage();
        // this.userInfoService.userData.UserId = 0;
        // this.toastr.error('Session time out. Please login again.', '');
        // this.router.navigate(["login"]); 
      }
      //Modified by PP(2023-10-24): Check for timeout of logincode - END

      //this.toEnableDisableObj(pWhichSolution, pWhichCombination, 'enable');
      this.sharedService.CalculationInProgress = false;
    });
  }

  ProceedToSaveOtherGas() {
    this.projectService.saveNewOtherGas(this.sharedService.OtherGasIDToSave).subscribe(data => {
      if (data.SuccessfulSaveOthers) {

        this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SAVECALCULATION').subscribe(result => {                       
          if (result) {}
        });

        //Get latest SaveOtherGas dropdown list
        this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord = data.CLDSaveOthersRecord;
        this.otherGassesList = data.CLDSaveOthersRecord;

        if (this.sharedService.OtherGasIDToSave[0] === 0) { //New Other Gas
        //   //Get Chemical ID and assign back to contamination class
          
          var updated = false;
          for (var x=0;x<this.projectService.projectdetails.contamination.gasDetails.length;x++) {
            if (this.projectService.projectdetails.contamination.gasDetails[x].otherGas) {
              if (this.projectService.projectdetails.contamination.gasDetails[x].otherGasDetails.otherContaminantName == this.sharedService.ServerData.OtherContaminationName) {                   
                this.projectService.projectdetails.contamination.gasDetails[x].chemicalID = data.NewChemID;
                this.projectService.projectdetails.contamination.gasDetails[x].otherGasDetails.otherContaminantID = data.NewChemID;
                updated = true;
                break;
              }
            }
          }
          if (updated) {
            this.sharedService.OtherGasIDToSave = [];
          }
          var abc=1123;
        } 

        
        //this.assignDetailsAfterConfirmOtherGasSelection();          
      } else {
        this.toastr.warning('Unable to save New Other Gas.', '');
      }                        
    });
  }

  //Modified by PP(2023-05-22) : If change gas - START
  removeGasFromSolutionsDetails(pChemIDToRemove, pChemNameToRemove, pConcValueToRemove) {
    var ConcValueToRemove = this.sharedService.convertLocaletoNumber(pConcValueToRemove, this.NumberFormat);

    //Remove from Solution Details
    for (var p=0;p<this.projectService.projectdetails.solutions.length;p++) {
      for (var q=0;q<this.projectService.projectdetails.solutions[p].solutionDetails.length;q++) {
        var removedSolutionDetails = false;
        if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.length>1) {
          //Remove only this gas
          for (var r=0;r<this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.length;r++) {
            var gasExist = false;
            //for (var s=0;s<this.contamination.gasDetails.length;s++) {             
            if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[r].chemicalID == pChemIDToRemove) {
              let solConcValue = this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[r].concentrationValue, this.NumberFormat);
              if (solConcValue == ConcValueToRemove) {
                gasExist = true;
                //break;
              }       
            }             
            //}
            if (gasExist) {
              this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas.splice(r, 1);
              r = r - 1;
            }
          }
        } else { 
          if (this.projectService.projectdetails.solutions[p].solutionDetails.length > 1) {
            var gasExist = false;
            //for (var s=0;s<this.contamination.gasDetails.length;s++) {
              if (this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[0].chemicalID == pChemIDToRemove) {
                let solConcValue = this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationGas[0].concentrationValue, this.NumberFormat);
                if (solConcValue == ConcValueToRemove) {
                  gasExist = true;
                  //break;
                }
              }
            //}
            if (gasExist) {
              removedSolutionDetails = true;
              this.projectService.projectdetails.solutions[p].solutionDetails.splice(q, 1);
              if (q === 0) {
                q = 0;
              } else {
                q = q - 1;
              }             
            }
          }

          //Only 1 Gas and only 1 solutiondetails then remove this solution        
          if (this.projectService.projectdetails.solutions[p].solutionDetails.length == 1 && removedSolutionDetails === false) {
            var gasExist = false;
            //for (var s=0;s<this.contamination.gasDetails.length;s++) {
              if (this.projectService.projectdetails.solutions[p].solutionDetails[0].combinationGas[0].chemicalID == pChemIDToRemove) {
                let solConcValue = this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.solutions[p].solutionDetails[0].combinationGas[0].concentrationValue, this.NumberFormat);
                if (solConcValue == ConcValueToRemove) {
                  gasExist = true;
                }                            
              }
            //}
    
            if (gasExist) {           
              this.projectService.projectdetails.solutions.splice(p, 1);
              if (p === 0) {
                p = 0;
                break; //Modified by PP(2023-05-19) : Bugs
              } else {
                p = p - 1;
              }              
            }           
          }
        }
      }

      //Reindex Solution Details
      if (this.projectService.projectdetails.solutions.length > 0) { //Modified by PP(2023-05-19) : Bugs
        for (var q=0;q<this.projectService.projectdetails.solutions[p].solutionDetails.length;q++) {
          this.projectService.projectdetails.solutions[p].solutionDetails[q].combinationID = q + 1;      
        }
      } //Modified by PP(2023-05-19) : Bugs    
    }

    //Reindex Solutions
    for (var p=0;p<this.projectService.projectdetails.solutions.length;p++) { 
      let oldSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID;          
      this.projectService.projectdetails.solutions[p].solutionID = p+1;
      let newSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID; 

      if (this.projectService.projectdetails.solutions[p].solutionName === oldSolName) {
        this.projectService.projectdetails.solutions[p].solutionName = newSolName;
      }
    }

    //If no solutions then create a solution
    if (this.projectService.projectdetails.solutions.length === 0) {
      var newSolution = this.projectService.getSolutionsForComparisonEmptyValueStructure();
      var newSolID = this.projectService.projectdetails.solutions.length + 1;
      newSolution.solutionID = newSolID;
      newSolution.solutionName = "Solution " + newSolID;
      this.projectService.projectdetails.solutions.push(newSolution);    
    }

    //Dunno what is this for this.contaminationChanged = true;
  }
  //Modified by PP(2023-05-22) : If change gas - END

  updateNewConcentrationToSolutions(pIndex, newConcValue) {
    for (let i=0 ; i< this.solutions.length; i++) {
      for (let j=0 ; j< this.solutions[i].solutionDetails.length; j++) {
        for (let k=0 ; k< this.solutions[i].solutionDetails[j].combinationGas.length; k++) {
          if (this.solutions[i].solutionDetails[j].combinationGas[k].index === pIndex) {
            this.solutions[i].solutionDetails[j].combinationGas[k].concentrationValue = this.sharedService.convertLocaletoNumber(newConcValue, this.NumberFormat);
          }
        }
      }
    }
  }

  //Modified by PP(2023-07-28) : Calculate Alternate Concentration Value - START
  updateAltConcValue(pIndex, pConcValue, pMolWt) {
    var altConcUnit = "";
    switch (this.projectService.projectdetails.projectInfo.concUnit) {
      case "ppb":
        altConcUnit = "mg/m³";
        this.contamination.gasDetails[pIndex].altConcUnit = "mg/m³";
        break;
      case "mg/m³":
        altConcUnit = "ppb";
        this.contamination.gasDetails[pIndex].altConcUnit = "ppb";
        break;
    }
    var CalculatedConcValue = this.calculateService.CalculateConcentration(pConcValue, altConcUnit, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.contamination.temperature, pMolWt);
    this.contamination.gasDetails[pIndex].altConcValue = this.sharedService.formatValue(CalculatedConcValue, true);
  }
}
